import React from "react";
import { View, Text } from "react-native";

export default function MaxesScreen(): JSX.Element {
  return (
    <View>
      <Text>Maxes</Text>
      <View />
    </View>
  );
}
